import Handler from '@/core/domain/usecase/handler';

const createModelRepository = (axios) => async (data) => {
  try {
    const response = await axios.post(`/model`,
      data
    )
    return response.data
  } catch (err) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createModelRepository
